import { Component } from '@angular/core';

@Component({
    selector: 'app-svg-shaped-image-clip-path',
    templateUrl: './svg-shaped-image-clip-path.component.html'
})
export class SvgShapedImageClipPathComponent
{
}
